import { render, staticRenderFns } from "./Asset.vue?vue&type=template&id=1ddee43c&scoped=true"
import script from "./Asset.vue?vue&type=script&lang=js"
export * from "./Asset.vue?vue&type=script&lang=js"
import style0 from "./Asset.vue?vue&type=style&index=0&id=1ddee43c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ddee43c",
  null
  
)

export default component.exports